import { Container } from "components";
import IntegrationsModule from "components/modules/IntegrationsModule";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { getParagonAuthToken } from "store/slices/crm.slice";
import { setCurrentPage } from "store/slices/ui.slice";
import EntryFormatter from "utils/EntryFormatter";

export const Integrations = () => {
  const dispatch = useAppDispatch();
  const { data: user } = useAppSelector((state) => state.user);
  const { isLoading: authIsLoading } = useAppSelector(
    (state) => state.crm.paragonAuth
  );
  useEffect(() => {
    window.analytics.page("Integrations");
    dispatch(setCurrentPage("integrations"));
    if (EntryFormatter.isObjectEmpty(user) || authIsLoading) return;
    try {
      dispatch(getParagonAuthToken());
    } catch (error) {
      console.error(error);
    }
  }, [user]);
  return (
    <Container className="p-5 gap-4 overflow-y-auto max-h-[80vh]">
      <IntegrationsModule />
    </Container>
  );
};
